import React from 'react';

import { SLASH_FULL_DATE_FORMAT } from 'core/constants';

import { formatFloating } from 'utils/formatters/timezone';

import CustomDatePicker from 'components/SharedFormComponents/CustomDatePicker';

import { Container } from './styles';
import { PickerProps } from '../types';

export const dateRangePickerValue = (value: [number, number]): string =>
  `${formatFloating(value[0], 'date', SLASH_FULL_DATE_FORMAT)} - ${formatFloating(value[1], 'date', SLASH_FULL_DATE_FORMAT)}`;

export const DatePickerRange: React.FunctionComponent<PickerProps> = ({ applyValue, item, ...props }) => {
  let [from, to] = (item.value as [string, string]) || [null, null];
  return (
    <Container>
      <p style={{ margin: 0 }}>from</p>
      <CustomDatePicker
        description=""
        {...props}
        testId="filter-range-from-field"
        onChange={(newValue) => {
          if (newValue && !Number.isNaN(newValue)) {
            applyValue({ ...item, value: [newValue as string, to] });
            from = newValue as string;
          }
        }}
        value={from}
      />
      <p style={{ margin: 0 }}>to</p>
      <CustomDatePicker
        description=""
        {...props}
        testId="filter-range-to-field"
        onChange={(newValue) => {
          if (newValue && !Number.isNaN(newValue)) {
            applyValue({ ...item, value: [from, newValue as string] });
            to = newValue as string;
          }
        }}
        value={to}
      />
    </Container>
  );
};
